var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { decode } from 'html-entities';
import { forwardRef, useContext } from 'react';
import { Text, View } from 'react-native';
import { StateConfigContext } from '../../../../providers';
import { getTestId } from '../../../../utils';
import { getGradientTextStyles, getGradientViewConfigData, getGradientViewProps, getGradientViewStyles } from './GradientTextStyles';
export var GradientText = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var gradientViewProps = getGradientViewProps(props, stateContext);
  var style = gradientViewProps.style,
    _gradientViewProps$te = gradientViewProps.testID,
    testID = _gradientViewProps$te === void 0 ? 'GradientText' : _gradientViewProps$te,
    typographyProps = gradientViewProps.typographyProps,
    restProps = __rest(gradientViewProps, ["style", "testID", "typographyProps"]);
  var gradientViewStyles = getGradientViewStyles(gradientViewProps);
  var _getGradientTextStyle = getGradientTextStyles(typographyProps),
    isUpperCase = _getGradientTextStyle.isUpperCase,
    styles = _getGradientTextStyle.styles;
  var text = decode(typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.text);
  text = isUpperCase && !(typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.noTextTransform) ? text.toUpperCase() : text;
  var _getGradientViewConfi = getGradientViewConfigData(gradientViewProps),
    colorSet = _getGradientViewConfi.colorSet;
  var lineHeight = styles.lineHeight,
    gradientTextStyles = __rest(styles, ["lineHeight"]);
  var colors = colorSet === null || colorSet === void 0 ? void 0 : colorSet.map(item => item === null || item === void 0 ? void 0 : item.stopColor);
  return _jsx(View, Object.assign({
    ref: ref,
    style: [gradientViewStyles.container, style]
  }, restProps, getTestId(testID), {
    children: _jsx(Text, Object.assign({}, restProps, {
      style: [gradientTextStyles, {
        background: "linear-gradient( 45deg," + colors.join() + ")",
        '-webkit-background-clip': 'text',
        '-webkit-text-fill-color': 'transparent',
        textAlign: typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.textAlignment
      }]
    }, {
      children: text
    }))
  }));
});